import { ErrorBase } from '@piri/error';

export default class AlertError extends ErrorBase {
  static get key() {
    return 'AlertError';
  }
}
